import { Injectable } from '@nestjs/common';
import { Repository, Raw, getConnection, getManager } from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import {HolidaysCalendar} from './holidays-calendar.entity';
import {HolidaysCalendarDTO} from './dto/holidays-calendar.dto';
import {HolidaysCalendarAdapter} from './dto/holidays-calendar.adapter';
import { HolidaysResponseModel, AllHolidaysCalendarResponseModel, HolidayNameColumns, HolidayDateReq } from '@gtpl/shared-models/hrms';
import { HolidaysCalendarRequest } from './dto/holidays-calendar.request';
import appSettings from 'apps/services/config';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import { HolidaysCalendarLog } from './holidays-calendar-log.entity';



@Injectable()
export class HolidaysCalenderService {
    constructor(
      private logService:LogsService,
        @InjectRepository(HolidaysCalendar)
        private holidaysCalendarRepo: Repository<HolidaysCalendar>,
        private Adapter: HolidaysCalendarAdapter,
    ){}
    /**
     * get holidayName details
     * @param holidayName 
     */
    // @LogActions({isAsync: true})
    async getHolidaysCalendarDetailsWithoutRelations(holidayName: string): Promise<HolidaysCalendar> {
        // tslint:disable-next-line: typedef
        const holidayCalendarResponse = await this.holidaysCalendarRepo.findOne({
          where: {holidayName: Raw(alias => `holiday_name = '${holidayName}'`)},
        });
        if (holidayCalendarResponse) {
          return holidayCalendarResponse;
        } else {
          return null;
        }
      }

      // async createHoliday(holidayDto: HolidaysCalendarDTO, isUpdate: boolean): Promise<HolidaysResponseModel> {
      //   // console.log(statesDto);
      //   try {
      //     // to check whether State exists with the passed  State code or not. if isUpdate is false, a check will be done whether a record with the passed Statecode is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed State code then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
      //     if (!isUpdate) {
      //       const holidaysCalendarEntity = await this.getHolidaysCalendarDetailsWithoutRelations(holidayDto.holidayName);
      //       if (holidaysCalendarEntity) {
      //         //return new InformationMessageError(11104, "State already exists");
      //         throw new ErrorResponse(11104, 'Holiday already exists');
      //       }
      //     }
      //     else{
      //       const holidaysCalendarEntity = await this.getHolidaysCalendarDetailsWithoutRelations(holidayDto.holidayName);
      //       if (holidaysCalendarEntity) {
      //         if(holidaysCalendarEntity.holidayId!=holidayDto.holidayId) {
      //           throw new ErrorResponse(11104, 'Holiday already exists');      
      //       }
      //         //return new InformationMessageError(11104, "State already exists");
      //       }
      //     }
      //     const convertedHolidaysCalendarEntity: HolidaysCalendar = this.Adapter.convertDtoToEntity(holidayDto,isUpdate);
      //     const savedHolidaysEntity: HolidaysCalendar = await this.holidaysCalendarRepo.save(
      //       convertedHolidaysCalendarEntity
      //     );
      //     const savedHolidayDto: HolidaysCalendarDTO = this.Adapter.convertEntityToDto(convertedHolidaysCalendarEntity);
      //       // console.log(savedStateDto);
      //     if (savedHolidayDto) {
      //       // generating resposnse
      //       const response = new HolidaysResponseModel(true,1,isUpdate? 'Holiday Updated Successfully': 'Holiday Created Successfully')
      //       const name=isUpdate?'updated':'created'
            
      //       const newLogDto = new LogsDto(1,name, 'HolidaysCalendar', savedHolidayDto.holidayId, true, '',savedHolidayDto.createdUser)
      //       let res = await this.logService.createLog(newLogDto);
      //       console.log(res);
      //       return response
      //     } else {
      //       //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
      //       throw new ErrorResponse(11106,'Holiday saved but issue while transforming into DTO');
      //     }
      //   } catch (error) {
      //     // when error occures while saving the data , the execution will come to catch block.
      //     // tslint:disable-next-line: typedef
      //     throw error;
      //   }
      // }  

      async createHoliday(formData: any): Promise<HolidaysResponseModel> {
        console.log(formData, 'oooooooser');
        const transactionManager = new GenericTransactionManager();
        try {
          await transactionManager.startTransaction();
          const flag = new Set<boolean>();
          const columnArray = [];
          const updatedArray = formData.data.map((obj) => {
            const updatedObj = {};
            for (const key in obj) {
              const newKey = key
                .replace(/\s/g, '')
                .replace(/[\(\)\.]/g, '')
                .replace(/-/g, '');
              if (newKey != '') {
                columnArray.push(newKey);
                updatedObj[newKey] = obj[key];
              }
            }
            return updatedObj;
          });
          const difference = columnArray.filter(
            (element) => !HolidayNameColumns.includes(element)
          );
          console.log(difference, '----');
          if (difference.length > 0) {
            await transactionManager.releaseTransaction();
            return new HolidaysResponseModel(
              false,
              1110,
              "Excel columns doesn't match. Please attach the correct file."
            );
          }
          const convertedData = updatedArray.map((obj) => {
            const updatedObj = {};
            for (const key in obj) {
              const value = obj[key];
              if (value === '') {
                updatedObj[key] = null;
              } else {
                updatedObj[key] = value;
              }
            }
            return updatedObj;
          });
          // const deleteData = await transactionManager.getRepository(vendorBanksEntity).delete({})
          // if (deleteData) {
          //     flag.add(true)
          // } else {
          //     flag.add(false)
          //     return new VendorBanksResponseModel(false, 0, 'Something wwent wrong in data deletion')
          // }
          for (const data of convertedData) {
            // let dtoData
            if (data.HolidayName != null) {
              const existedData = await this.holidaysCalendarRepo.findOne({
                where: {
                 
                  holidayName: data.HolidayName,
                  holidayDate:data.HolidayDate
                },
              });
              if (existedData) {
                const update = await transactionManager
                  .getRepository(HolidaysCalendar)
                  .update({ holidayId: existedData.holidayId }, { holidayName: data.HolidayName,holidayDate:data.HolidayDate ,updatedUser:existedData.createdUser});
                if (!update.affected) {
                  flag.add(false);
                  await transactionManager.releaseTransaction();
                  return new CommonResponse(
                    false,
                    0,
                    'Something went wrong in updating existing record'
                  );
                } else {
                  const logs = new HolidaysCalendarLog();
                  
                  logs.holidayName = existedData.holidayName;
                  logs.holidayDate=existedData.holidayDate
                  logs.holidaysCalendarId = existedData.holidayId;
                  const addupdatedData = await transactionManager
                    .getRepository(HolidaysCalendarLog)
                    .save(logs);
                  if (addupdatedData) {
                    flag.add(true);
                  } else {
                    flag.add(false);
                    await transactionManager.releaseTransaction();
                    break;
                  }
                }
              } else {
                const addObj = new HolidaysCalendar();
               addObj.createdUser = formData.user
                addObj.holidayName = data.HolidayName;
                addObj.holidayDate=data.HolidayDate
                const addSave = await transactionManager
                  .getRepository(HolidaysCalendar)
                  .save(addObj);
                if (addSave) {
                  flag.add(true);
                } else {
                  flag.add(false);
                  await transactionManager.releaseTransaction();
                  return new HolidaysResponseModel(false, 0, 'Somthing went wrong in saving the data');
                }
              }
            }
          }
          if (!flag.has(false)) {
            await transactionManager.completeTransaction();
            return new HolidaysResponseModel(true, 1, 'Data saved successfully');
          } else {
            await transactionManager.releaseTransaction();
            return new HolidaysResponseModel(false, 0, 'Something went wrong');
          }
        } catch (err) {
          await transactionManager.releaseTransaction();
          return new HolidaysResponseModel(false, 0, 'Something went wrong');
        }
      }


    //   async createHoliday(formData: any): Promise<HolidaysResponseModel> {
    //     const transactionManager = new GenericTransactionManager();
    //     try {
    //         // Start transaction
    //         await transactionManager.startTransaction();
    
    //         // Validate date format for each entry in formData
    //         const isValidDateFormat = formData.data.every(obj => moment(obj.holidayDate, 'DD-MM-YYYY', true).isValid());
    
    //         // If any date is in invalid format, return error response
    //         if (!isValidDateFormat) {
    //             await transactionManager.releaseTransaction();
    //             return new HolidaysResponseModel(false, 0, "Invalid date format. Date must be in DD-MM-YYYY format.");
    //         }
    
    //         // Transform column names
    //         const columnArray = [];
    //         const updatedArray = formData.data.map((obj) => {
    //             const updatedObj = {};
    //             for (const key in obj) {
    //                 const newKey = key
    //                     .replace(/\s/g, '')
    //                     .replace(/[\(\)\.]/g, '')
    //                     .replace(/-/g, '');
    //                 if (newKey != '') {
    //                     columnArray.push(newKey);
    //                     updatedObj[newKey] = obj[key];
    //                 }
    //             }
    //             return updatedObj;
    //         });
    
    //         // Check column names against predefined names
    //         const difference = columnArray.filter(
    //             (element) => !HolidayNameColumns.includes(element)
    //         );
    //         if (difference.length > 0) {
    //             await transactionManager.releaseTransaction();
    //             return new HolidaysResponseModel(
    //                 false,
    //                 1110,
    //                 "Excel columns don't match. Please attach the correct file."
    //             );
    //         }
    
    //         // Convert data, replacing empty strings with null
    //         const convertedData = updatedArray.map((obj) => {
    //             const updatedObj = {};
    //             for (const key in obj) {
    //                 const value = obj[key];
    //                 if (value === '') {
    //                     updatedObj[key] = null;
    //                 } else {
    //                     updatedObj[key] = value;
    //                 }
    //             }
    //             return updatedObj;
    //         });
    
    //         // Iterate over each entry in convertedData
    //         const flag = new Set<boolean>();
    //         for (const data of convertedData) {
    //             if (data.HolidayName != null) {
    //                 const existedData = await this.holidaysCalendarRepo.findOne({
    //                     where: {
    //                         holidayName: data.HolidayName,
    //                         holidayDate: data.HolidayDate
    //                     },
    //                 });
    //                 if (existedData) {
    //                     // Update existing record
    //                     const update = await transactionManager
    //                         .getRepository(HolidaysCalendar)
    //                         .update({ holidayId: existedData.holidayId }, { holidayName: data.HolidayName, holidayDate: data.HolidayDate, updatedUser: existedData.createdUser });
    //                     if (!update.affected) {
    //                         flag.add(false);
    //                         await transactionManager.releaseTransaction();
    //                         return new CommonResponse(
    //                             false,
    //                             0,
    //                             'Something went wrong in updating existing record'
    //                         );
    //                     } else {
    //                         // Log changes
    //                         const logs = new HolidaysCalendarLog();
    //                         logs.holidayName = existedData.holidayName;
    //                         logs.holidayDate = existedData.holidayDate;
    //                         logs.holidaysCalendarId = existedData.holidayId;
    //                         const addupdatedData = await transactionManager
    //                             .getRepository(HolidaysCalendarLog)
    //                             .save(logs);
    //                         if (addupdatedData) {
    //                             flag.add(true);
    //                         } else {
    //                             flag.add(false);
    //                             await transactionManager.releaseTransaction();
    //                             break;
    //                         }
    //                     }
    //                 } else {
    //                     // Create new record
    //                     const addObj = new HolidaysCalendar();
    //                     addObj.createdUser = formData.user;
    //                     addObj.holidayName = data.HolidayName;
    //                     addObj.holidayDate = data.HolidayDate;
    //                     const addSave = await transactionManager
    //                         .getRepository(HolidaysCalendar)
    //                         .save(addObj);
    //                     if (addSave) {
    //                         flag.add(true);
    //                     } else {
    //                         flag.add(false);
    //                         await transactionManager.releaseTransaction();
    //                         return new HolidaysResponseModel(false, 0, 'Something went wrong in saving the data');
    //                     }
    //                 }
    //             }
    //         }
    
    //         // Check if all operations were successful
    //         if (!flag.has(false)) {
    //             await transactionManager.completeTransaction();
    //             return new HolidaysResponseModel(true, 1, 'Data saved successfully');
    //         } else {
    //             await transactionManager.releaseTransaction();
    //             return new HolidaysResponseModel(false, 0, 'Something went wrong');
    //         }
    //     } catch (err) {
    //         // Handle errors and release transaction
    //         await transactionManager.releaseTransaction();
    //         return new HolidaysResponseModel(false, 0, 'Something went wrong');
    //     }
    // }
      async getAllHolidays(): Promise<AllHolidaysCalendarResponseModel> {
        // const page: number = 1;
        
        try {
          const holidayDtos: HolidaysCalendarDTO[] = [];
          //retrieves all companies
          const holidaysCalendarEntities: HolidaysCalendar[] = await this.holidaysCalendarRepo.find({order :{'createdAt':'DESC'}});
          //console.log(statesEntities);
          if (holidaysCalendarEntities) {
            // converts the data fetched from the database which of type companies array to type StateDto array.
            holidaysCalendarEntities.forEach(HolidaysCalendarEntity => {
              const convertedholidayDto: HolidaysCalendarDTO = this.Adapter.convertEntityToDto(
                HolidaysCalendarEntity
              );
              holidayDtos.push(convertedholidayDto);
            });
            const response = new AllHolidaysCalendarResponseModel(true,1,'Holiday retrieved successfully',holidayDtos);
            //generated response
            const newLogDto = new LogsDto(1,'view', 'HolidaysCalendar', 0, true, '','')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            return response
          } else {
            throw new ErrorResponse(99998, 'Data not found');
          }
        
        } catch (err) {
          throw err;
        }
      }
      async getAllActiveHolidays(): Promise<AllHolidaysCalendarResponseModel> {
        // const page: number = 1;
        try {
            const holidayDto: HolidaysCalendarDTO[] = [];
            //retrieves all expenses Categories
            const holidaysCalendarEntities: HolidaysCalendar[] = await this.holidaysCalendarRepo.find({ order: { 'holidayName': 'ASC' },where:{isActive:true},
           });
         console.log(holidaysCalendarEntities)
            if (holidaysCalendarEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                holidaysCalendarEntities.forEach(holidaysCalendarEntity => {
                    const convertedholidayDto: HolidaysCalendarDTO = this.Adapter.convertEntityToDto(
                      holidaysCalendarEntity
                      
                    );
                    holidayDto.push(convertedholidayDto);
                });
                const response = new AllHolidaysCalendarResponseModel(true, 11108, "Holidays Calendar retrieved successfully", holidayDto);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data not found'); holidayDto
            }
        } catch (err) {
            throw err;
        }
    }
      async activateOrDeactivateHoliday(holidayCalendarReq: HolidaysCalendarRequest): Promise<HolidaysResponseModel> {
        try {
            const holidayExists = await this.getHolidayById(holidayCalendarReq.holidayId);
            if (holidayExists) {
                if (holidayCalendarReq.versionFlag !== holidayExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current Holiday information.Refresh and try again');
                } else {
                    
                        const holidayStatus =  await this.holidaysCalendarRepo.update(
                            { holidayId: holidayCalendarReq.holidayId },
                            { isActive: holidayCalendarReq.isActive,updatedUser: holidayCalendarReq.updatedUser });
                       
                        if (holidayExists.isActive) {
                            if (holidayStatus.affected) {
                                const holidayCalendarResponse: HolidaysResponseModel = new HolidaysResponseModel(true, 10115, 'HolidaysCalendar is de-activated successfully');
                                return holidayCalendarResponse;
                            } else {
                                throw new ErrorResponse(10111, 'Holidays Calendar is already deactivated');
                            }
                        } else {
                            if (holidayStatus.affected) {
                                const holidayCalendarResponse: HolidaysResponseModel = new HolidaysResponseModel(true, 10114, 'HolidaysCalendar is activated successfully');
                                return holidayCalendarResponse;
                            } else {
                                throw new ErrorResponse(10112, 'Holidays Calendar is already  activated');
                            }
                        }
                    // }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }
      async getActiveHolidaysById(holidayCalendarReq: HolidaysCalendarRequest): Promise<HolidaysResponseModel> {
        try {
          //retrieves all companies
          const holidaysCalendarEntities: HolidaysCalendar = await this.holidaysCalendarRepo.findOne({
              where:{holidayId:holidayCalendarReq.holidayId}
              });
              
              const holidaysCalendarData: HolidaysCalendarDTO = this.Adapter.convertEntityToDto(holidaysCalendarEntities);
              if (holidaysCalendarData) {
                  const response = new HolidaysResponseModel(true, 11101 , 'Holidays Calendar retrived Successfully',holidaysCalendarData);
                  return response;
              }
              else{
                  throw new ErrorResponse(11106,'Something went wrong');
              }
              // generating resposnse
      } catch (err) {
          throw err;
      }
    }

    async getHolidayById(holidayId: number): Promise<HolidaysCalendar> {
        //  console.log(employeeId);
            const Response = await this.holidaysCalendarRepo.findOne({
            where: {holidayId: holidayId},
            });
            // console.log(employeeResponse);
            if (Response) {
            return Response;
            } else {
            return null;
            }
        }

      async getHolidaysForYear():Promise<CommonResponse>{
        try{
          const manager = getManager()
          let query = `select h.holiday_name as holidayName,Date(h.holiday_date) as holidayDate from ` + appSettings.hrms_db + `.holidays_calendar h where h.holiday_date = year(curdate())`
          const data = await manager.query(query)
          if(data && data.length > 0){
            return new CommonResponse(true,1111,'Data Retreived',data)
          }else{
            return new CommonResponse(false,1111,'No data')
          }
         
        }catch(error){
          return error
        }

      }
      async getAllActiveHolidaysByNextDay(req:HolidayDateReq):Promise<CommonResponse>{
        try{
          const manager = getManager()
          let query = `SELECT h.holiday_name as holidayName,h.holiday_date as holidayDate , h.is_active AS isActive from ` + appSettings.hrms_db + `.holidays_calendar h where h.is_active = true AND h.holiday_date = '${req.holidayDate}'`
          const data = await manager.query(query)
          if(data && data.length > 0){
            return new CommonResponse(true,1111,'Data Retrieved',data)
          }else{
            return new CommonResponse(false,1111,'No data')
          }
        }catch(error){
          return error
        }
      }
}
